import React from 'react';
import { scroller } from 'react-scroll';
import { Typography } from '@material-ui/core';
import s from './Good.module.scss';

const Description = props => {
  const { goodData, t } = props;

  const clickElement = idEl => {
    const el = document.getElementById(idEl);
    if (el) {
      el.click();
      scroller.scrollTo(idEl, {
        duration: 800,
        delay: 0,
        smooth: 'easeInOutQuart',
        offset: -80
      });
    }
  };

  return (
    <div className={s.description}>
      <div
        className={s.descriptionPreview}
        dangerouslySetInnerHTML={{ __html: goodData.description_preview }}
      />
      {goodData.description_full && (
        <Typography
          color="primary"
          className={s.cursorPointer}
          onClick={() => clickElement('tabpanel-2-description-tab-catalog')}
        >
          {t['Читать полное описание']}
        </Typography>
      )}
      {goodData.specifications && (
        <Typography
          color="primary"
          className={s.cursorPointer}
          onClick={() => clickElement('tabpanel-2-characteristic-tab-catalog')}
        >
          {t['Подробные характеристики']}
        </Typography>
      )}
      {goodData.additional_information && (
        <div
          dangerouslySetInnerHTML={{
            __html: goodData.additional_information
          }}
        />
      )}
    </div>
  );
};

export default Description;
